import { useState } from "react";
import axios from "axios";
import "./BlueTickButton.css";
import { RAZORPAY_BRAND } from "../utils/razorpayBranding";

function PremiumBadgeButton() {
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("token");

  const BASE_URL =
    window.location.hostname === "localhost"
      ? "http://localhost:5000"
      : "https://success-blog-app-backend.onrender.com";


  const loadRazorpayScript = () => {
    return new Promise((resolve) => {

      if (window.Razorpay) {
        resolve(true);
        return;
      }

      const script = document.createElement("script");

      script.src =
        "https://checkout.razorpay.com/v1/checkout.js";

      script.async = true;

      script.onload = () => resolve(true);

      script.onerror = () => resolve(false);

      document.body.appendChild(script);
    });
  };


  const handlePremium = async () => {

    setLoading(true);

    try {

      const loaded = await loadRazorpayScript();

      if (!loaded) {
        alert("Unable to load Razorpay");
        return;
      }


      const { data } = await axios.post(
        `${BASE_URL}/api/payment/create-order`,
        {},
        {
          headers:{
            Authorization:`Bearer ${token}`
          }
        }
      );


      const options = {

        key:data.key,

        amount:data.amount,

        currency:data.currency,

        order_id:data.orderId,


        ...RAZORPAY_BRAND,

        description:"Premium Membership Badge",


        handler:async function(response){

          try{


            const verify = await axios.post(

              `${BASE_URL}/api/payment/verify-payment`,

              {
                razorpay_order_id:
                  response.razorpay_order_id,

                razorpay_payment_id:
                  response.razorpay_payment_id,

                razorpay_signature:
                  response.razorpay_signature,
              },

              {
                headers:{
                  Authorization:`Bearer ${token}`
                }
              }

            );


            if(verify.data.success){

              alert(
                "🎉 Premium Badge Activated Successfully!"
              );

              window.location.reload();

            }
            else{

              alert("Payment Verification Failed");

            }


          }
          catch(err){

            console.log(err);

            alert(
              "Payment Verification Failed"
            );

          }

        },


        prefill:{

          name:
          localStorage.getItem("username") || "",

          email:
          localStorage.getItem("email") || "",

        },


        notes:{
          feature:"Premium Badge"
        },


        theme:{
          color:"#2563eb"
        },


        modal:{
          ondismiss:function(){

            console.log(
              "Payment Closed"
            );

          }
        }

      };


      const razorpay =
        new window.Razorpay(options);


      razorpay.on(
        "payment.failed",
        function(response){

          alert(
            response.error.description ||
            "Payment Failed"
          );

        }
      );


      razorpay.open();


    }
    catch(err){

      console.error(err);

      alert(
        err.response?.data?.message ||
        "Unable to create payment order"
      );

    }
    finally{

      setLoading(false);

    }

  };


  return (

    <div className="blue-tick-card">

      <div className="badge">
        PREMIUM
      </div>


      <div className="card-header">

        <div className="tick-icon">
          ⭐
        </div>


        <h2>
          Get Premium Badge
        </h2>


        <p className="subtitle">
          Unlock premium identity and features on TheBlogsSphere
        </p>

      </div>



      <div className="price-section">

        <span className="price">
          ₹1
        </span>

        <span className="period">
          / 30 days
        </span>

      </div>



      <ul className="features-list">

       <ul className="features-list">

  <li>
    ✅ <b>Premium Badge</b> on your profile
  </li>

  <li>
    ✅ Priority support from our team
  </li>

  <li>
    ✅ 🎁 Get 5 free streak protection rewards
  </li>

  <li>
    ✅ 🚀 Boost your blog visibility through our Premium Creator feed
  </li>

  <li>
    ✅ 🔄 Fair rotation system ensures premium members get equal discovery opportunities
  </li>

  <li>
    ✅ ⏰ Premium blogs are rotated regularly (approximately every 10 minutes) in the featured section
  </li>

  <li>
    ✅ Valid for 30 days
  </li>

</ul>


<p className="subtitle">
  Premium members get extra blog visibility through our fair rotation system.
  Featured premium blogs rotate regularly so every creator gets an opportunity
  to reach more readers.
</p>
      </ul>




      <button

        onClick={handlePremium}

        disabled={loading}

        className="blue-tick-btn"

      >

        {
          loading
          ? "Processing Payment..."
          : "Get Premium Badge"
        }

      </button>




      <p className="footer-note">

        Secure payment powered by Razorpay.

      </p>


    </div>

  );

}


export default PremiumBadgeButton;